import EnhancedHero from "../components/sections/EnhancedHero"
import About from "../components/sections/About"
import Skills from "../components/sections/Skills"
import Experience from "../components/sections/Experience"
import Projects from "../components/Projects"
import Certificates from "../components/sections/Certificates"
import Contact from "../components/sections/Contact"

const Home = () => {
  return (
    <div>
      <EnhancedHero />
      <About />
      <Skills />
      <Experience />
      <Projects />
      <Certificates />
      <Contact />
    </div>
  )
}

export default Home
